export default "__VITE_ASSET__e677200b__"